/* Live total under the booking form's "characters" question. The form is injected by the
   Globo Product Options app, so wait for its fields before attaching. */
(() => {
  if (customElements.get('meek-total')) return;

  class MeekTotal extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.per = Number(this.dataset.per) || 65;
      this.stackFee = Number(this.dataset.stack) || 0;
      this.deposit = Number(this.dataset.deposit) || 0;
      this.form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (!this.form) return;
      this.tryAttach() || this.watch();
    }

    watch() {
      const mo = new MutationObserver(() => { if (this.tryAttach()) mo.disconnect(); });
      mo.observe(this.form, { childList: true, subtree: true });
      setTimeout(() => mo.disconnect(), 15000);
    }

    tryAttach() {
      const input = this.form.querySelector('input[name="Characters"]');
      if (!input) return false;
      this.input = input;
      const anchor = input.closest('[class*="gpo-element"], [class*="gpo-form__group"], .gpo-field') || input.parentElement;
      anchor.after(this);
      this.hidden = false;
      this.render();
      // Update once typing pauses, so the number never ticks up letter by letter.
      this.form.addEventListener('input', (e) => {
        if (e.target !== input) return;
        clearTimeout(this.pause);
        this.pause = setTimeout(() => this.render(), 700);
      });
      input.addEventListener('blur', () => { clearTimeout(this.pause); this.render(); });
      this.form.addEventListener('change', (e) => { if (e.target.name === 'stacked') this.render(); });
      return true;
    }

    render() {
      const chars = (this.input.value || '').replace(/\s/g, '').length;
      const stacked = this.form.querySelector('input[name="stacked"]:checked')?.value === 'Yes';
      const today = `<span class="meek-pdp-total__today"><strong>$${this.deposit} today</strong> holds your date</span>`;
      if (!chars) {
        this.innerHTML = `${today}<span class="meek-pdp-total__est">Each letter, number or symbol is $${this.per}. Spaces are free.</span>`;
        return;
      }
      const total = chars * this.per + (stacked ? this.stackFee : 0);
      this.innerHTML = `${today}
        <span class="meek-pdp-total__est">Estimated total <strong>$${total.toLocaleString('en-US')}</strong> (${chars} ${chars === 1 ? 'character' : 'characters'} at $${this.per} each${stacked ? `, plus $${this.stackFee} for stacking` : ''})</span>
        <span class="meek-pdp-total__due">The rest is invoiced the month of your event.</span>`;
    }
  }

  customElements.define('meek-total', MeekTotal);
})();
